import styled from '@emotion/styled';
import {
  CancelOutlined,
  CheckCircle,
  LaunchOutlined,
  LaunchSharp,
  SettingsApplications
} from '@mui/icons-material';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography
} from '@mui/material';
import { Link } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import { settingsTabStateAtom } from '../social/atom';

const { useEffect, useState } = require('react');

const Pbox = styled.p`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  gap: 0.5rem;
`;

const LinkText = styled.label`
  display: inline-flex;
  gap: 0.1rem;
  align-items: center;
  font-weight: bold;
  cursor: pointer;
  color: #1976d2;
`;
const ShowWordpressOnBoarding = ({ userData }) => {
  const [open, setOpen] = useState(false);
  const setDefaultSettingsTab = useSetRecoilState(settingsTabStateAtom);

  useEffect(() => {
    if (userData) {
      // console.log(userData);
      if (
        !userData?.openai_keys ||
        userData?.openai_keys.length === 0 ||
        !userData?.dc_creds ||
        userData?.dc_creds.length === 0 ||
        userData?.default_wp_settings.openai_key === '' ||
        userData?.default_wp_settings.selected_dc_cred === -1
      ) {
        setOpen(true);
      } else {
        setOpen(false);
      }
    }
  }, [userData]);

  return (
    <Dialog onClose={() => true} open={open}>
      <DialogTitle>Almost There!</DialogTitle>

      <DialogContent>
        <Typography variant="body1">
          Before you start, make sure you have the following settings configured. click on the
          action items to setup the incomplete settings.
        </Typography>
        <DialogContentText>
          <Pbox>
            {!userData?.openai_keys || userData?.openai_keys.length === 0 ? (
              <CancelOutlined color="error" />
            ) : (
              <CheckCircle color="success" />
            )}
            <Link to="/credentials?tab=AI">
              <LinkText>
                Add <LaunchOutlined fontSize="10px" />
              </LinkText>{' '}
              at least one OpenAI key
            </Link>
          </Pbox>
          <Pbox>
            {!userData?.dc_creds || userData?.dc_creds.length === 0 ? (
              <CancelOutlined color="error" />
            ) : (
              <CheckCircle color="success" />
            )}
            <Link to="/credentials?tab=image">
              <LinkText>
                Add <LaunchOutlined fontSize="10px" />
              </LinkText>{' '}
              at least one credential for image generation
            </Link>
          </Pbox>
          <Pbox>
            {userData?.default_wp_settings.openai_key === '' ||
            userData?.default_wp_settings.selected_dc_cred === -1 ? (
              <CancelOutlined color="error" />
            ) : (
              <CheckCircle color="success" />
            )}

            <Link
              to="/wordpress_sites/default"
              onClick={() => setDefaultSettingsTab('Credentials')}
            >
              <LinkText>
                Check <LaunchOutlined fontSize="10px" />
              </LinkText>{' '}
              your default wordpress settings. These settings will be applied to all the sites you
              add by default
            </Link>
          </Pbox>
        </DialogContentText>

        <DialogActions>
          <Link to="/">
            <Button variant="outlined" color="primary">
              Go to Dashboard
            </Button>
          </Link>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default ShowWordpressOnBoarding;
